export const KEY = 'cotrustee'
